module.exports = __webpack_public_path__ + "img/833-loop.ba9c6cd4.svg";